import $ from 'jquery';

$( document ).ready( function() {
	$( '.styleguide-module-title' ).click( function() {
		$( this ).parent().find( '.parameter-infos' ).slideToggle();
	} );

	$( '.parameter-infos .closeit' ).click( function() {
		$( this ).parent().slideToggle();
	} );
} );
